export const VISIT_STATUS_STYLES = {
  requested: "bg-gold/20 text-pine border-gold/40",
  confirmed: "bg-pine text-cream border-pine",
  completed: "bg-sage/15 text-sage border-sage/30",
  cancelled: "bg-red-50 text-red-700 border-red-200",
  new: "bg-gold/20 text-pine border-gold/40",
  replied: "bg-pine text-cream border-pine",
  closed: "bg-sage/15 text-sage border-sage/30",
  paid: "bg-brand text-cream border-brand",
  pending: "bg-white text-sage border-sand",
};

export const StatusBadge = ({ value, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center rounded-full border px-2.5 py-1 font-mono text-[9px] uppercase tracking-[0.18em] ${
      VISIT_STATUS_STYLES[value] || "bg-white text-sage border-sand"
    }`}
  >
    {value}
  </span>
);

export const fmtDate = (ymd) => {
  if (!ymd) return "";
  const [y, m, d] = ymd.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-IN", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const fmtStamp = (iso) => {
  try {
    return new Date(iso).toLocaleString("en-IN", {
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "";
  }
};

export const FilterTabs = ({ options, value, onChange, counts = {}, prefix }) => (
  <div className="flex flex-wrap gap-2">
    {options.map((o) => (
      <button
        key={o}
        data-testid={`${prefix}-filter-${o}`}
        onClick={() => onChange(o)}
        className={`rounded-full border px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] transition-colors duration-300 ${
          value === o
            ? "border-pine bg-pine text-cream"
            : "border-sand bg-white text-sage hover:border-pine/50 hover:text-pine"
        }`}
      >
        {o}
        {counts[o] !== undefined && (
          <span className={`ml-2 ${value === o ? "text-gold" : "text-sage/70"}`}>{counts[o]}</span>
        )}
      </button>
    ))}
  </div>
);
